// extracted by mini-css-extract-plugin
module.exports = {"playVideoClick":"PlayVideoClick_playVideoClick__33-jn"};